import { render, staticRenderFns } from "./supFrom.vue?vue&type=template&id=89f1641e"
import script from "./supFrom.vue?vue&type=script&lang=js"
export * from "./supFrom.vue?vue&type=script&lang=js"
import style0 from "./supFrom.vue?vue&type=style&index=0&id=89f1641e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports